import { render } from "./App.vue?vue&type=template&id=c9903b98"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c9903b98&lang=css"

import exportComponent from "D:\\项目\\王守岩代码\\长护险\\dp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__